(function() {
	PM.Feedback = {};

	var MAX_FILES = 5;
	var MAX_FILE_SIZE = 5 * 1024 * 1024;

	var acceptedTypes = ['image/png', 'image/jpeg', 'image/gif', 'image/webp'];

	function createThumbnail(file, previewUrl) {
		var $item = $('<div>').addClass('position-relative');
		var $img = $('<img>').attr('src', previewUrl).css({ width: '64px', height: '64px', objectFit: 'cover', borderRadius: '4px' });
		var $remove = $('<button>').addClass('btn-close position-absolute js-feedback-remove-attachment')
			.attr('type', 'button')
			.attr('aria-label', 'Remove')
			.css({ top: '-4px', right: '-4px', width: '18px', height: '18px', fontSize: '10px' });

		$item.append($img).append($remove);
		$item.data('file', file);
		$item.data('previewUrl', previewUrl);

		return $item;
	}

	function addFiles($modal, newFiles) {
		var $previews = $modal.find('.js-feedback-previews');
		var currentCount = $previews.children().length;

		for (var i = 0; i < newFiles.length; i++) {
			var file = newFiles[i];

			if (currentCount >= MAX_FILES) {
				new Notify({ status: 'warning', text: i18next.t('Maximum 5 attachments allowed.'), timeout: 3000 });
				break;
			}

			if (acceptedTypes.indexOf(file.type) === -1) continue;
			if (file.size > MAX_FILE_SIZE) {
				new Notify({ status: 'error', text: i18next.t('File is too large. Maximum size is 5 MB.'), timeout: 3000 });
				continue;
			}

			var previewUrl = URL.createObjectURL(file);
			var $thumb = createThumbnail(file, previewUrl);
			$previews.append($thumb);
			currentCount++;
		}
	}

	function gatherFiles($modal) {
		var files = [];
		$modal.find('.js-feedback-previews').children().each(function() {
			var file = $(this).data('file');
			if (file) files.push(file);
		});
		return files;
	}

	function clearPreviews($modal) {
		$modal.find('.js-feedback-previews').children().each(function() {
			var url = $(this).data('previewUrl');
			if (url) URL.revokeObjectURL(url);
		});
		$modal.find('.js-feedback-previews').empty();
	}

	PM.Feedback.showModal = function() {
		$.when(
			ejs.preloadTemplate('/app/feedback/templates/feedback-modal.ejs')
		).done(function() {
			var modalHtml = ejs.rr('/app/feedback/templates/feedback-modal.ejs', {});
			var $modal = $(modalHtml);
			$('body').append($modal);
			var bsModal = new bootstrap.Modal($modal[0]);
			bsModal.show();

			$modal.on('shown.bs.modal', function() {
				$modal.find('.js-feedback-message').focus();
			});

			$modal.on('hidden.bs.modal', function() {
				clearPreviews($modal);
				$modal.remove();
			});
		});
	};

	$(document).on('click', '.js-feedback-open', function(e) {
		e.preventDefault();
		PM.Feedback.showModal();
	});

	$(document).on('paste', function(e) {
		var $modal = $('.js-feedback-modal');
		if (!$modal.length || !$modal.is(':visible')) return;

		var clipboardData = e.originalEvent.clipboardData;
		if (!clipboardData || !clipboardData.items) return;

		var imageFiles = [];
		for (var i = 0; i < clipboardData.items.length; i++) {
			var item = clipboardData.items[i];
			if (item.type.indexOf('image/') === 0) {
				var file = item.getAsFile();
				if (file) imageFiles.push(file);
			}
		}

		if (imageFiles.length > 0) {
			e.preventDefault();
			addFiles($modal, imageFiles);
		}
	});

	$(document).on('change', '.js-feedback-file-input', function(e) {
		var $modal = $(this).closest('.js-feedback-modal');
		var files = e.target.files;
		if (!files || files.length === 0) return;

		addFiles($modal, Array.from(files));
		e.target.value = '';
	});

	$(document).on('click', '.js-feedback-remove-attachment', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var $item = $(this).closest('.position-relative');
		var url = $item.data('previewUrl');
		if (url) URL.revokeObjectURL(url);
		$item.remove();
	});

	$(document).on('dragover', '.js-feedback-previews', function(e) {
		e.preventDefault();
		e.stopPropagation();
	});

	$(document).on('drop', '.js-feedback-previews, .js-feedback-message', function(e) {
		e.preventDefault();
		e.stopPropagation();
		var $modal = $(this).closest('.js-feedback-modal');
		var files = e.originalEvent.dataTransfer.files;
		if (!files || files.length === 0) return;
		addFiles($modal, Array.from(files));
	});

	$(document).on('click', '.js-feedback-send', function(e) {
		e.preventDefault();
		var $modal = $(this).closest('.js-feedback-modal');
		var $textarea = $modal.find('.js-feedback-message');
		var message = $textarea.val().trim();
		var files = gatherFiles($modal);

		if (!message && files.length === 0) {
			new Notify({ status: 'error', text: i18next.t('Please enter a message.'), timeout: 3000 });
			return;
		}

		var $btn = $(this);
		$btn.prop('disabled', true).text(i18next.t('Sending...'));

		var formData = new FormData();
		formData.append('message', message);
		formData.append('url', location.href);
		for (var i = 0; i < files.length; i++) {
			formData.append('attachments', files[i]);
		}

		$.ajax({
			url: '/api/feedback',
			method: 'POST',
			processData: false,
			contentType: false,
			data: formData
		}).done(function() {
			$modal.modal('hide');
			new Notify({ status: 'success', text: i18next.t('Thank you for your feedback!'), timeout: 4000 });
		}).fail(function(xhr) {
			xhr.handled = true;
			var errorMsg = i18next.t('Failed to send feedback.');
			if (xhr.responseJSON && xhr.responseJSON.error) {
				errorMsg = xhr.responseJSON.error;
			}
			new Notify({ status: 'error', text: errorMsg, timeout: 4000 });
		}).always(function() {
			$btn.prop('disabled', false).text(i18next.t('Send'));
		});
	});
})();
